import { Box, Paper, TableBody, TableCell, Table, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../../../global/config/store';
import { useDispatch } from 'react-redux';
import { setPageData, setRowsPerPageData } from '../../../global/config/Reducer/paginationSlice.ts';
import { ApiGetVenueList, ApiReportTempToken } from '../../../apiService/Core/Apicall.tsx';
import dayjs, { Dayjs } from 'dayjs';
import edit from '../../../assets/images/editIcon.png'
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import it from 'date-fns/esm/locale/it/index.js';
import { ApigetPastReports } from '../../../apiService/Core/CustomApiManageReports.tsx';

function VenueReportStatus() {

    const [datalength, setdatalength] = useState<any>(null);
    const { id } = useParams();
    const storedData = localStorage.getItem("venueReportData");
    // const venuedata = storedData ? JSON.parse(storedData) : null; 
    const [venuedata, setvVenuedata] = useState<any>([])
    const paginationPage = useSelector((state: RootState) => state.VenueStatusPagination.page)
    const paginationRowsPerPage = useSelector((state: RootState) => state.VenueStatusPagination.rowsPerPage)
    const [page, setPage] = useState(paginationPage);
    const [rowsPerPage, setRowsPerPage] = useState(paginationRowsPerPage);
    const dispatch = useDispatch()
    const [reportdetails, setreportdetails] = useState<any>()


  const handleGetVenueList = async () => {
    const data = `?venueId=${id}`;
    try {
      const response: any = await ApiGetVenueList(data);
      setvVenuedata(response?.data[0]);
    } catch (error) {
      console.error("Error during API call:", error);
    }
  };
  useEffect(()=>{
 id && handleGetVenueList()
  },[id])


    const handleChangePage = (_event: unknown, newPage: number) => {
        setPage(newPage);
        dispatch(setPageData(newPage))
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        dispatch(setRowsPerPageData(parseInt(event.target.value, 10)))
        dispatch(setPageData(0));
    };

    const getreportdetails = async () => {
        if(!venuedata?.venueId) return
        try {
            console.log("Venue Data--->", venuedata)
            const data = `?venueId=${venuedata?.venueId}&offset=${page * rowsPerPage}&limit=${rowsPerPage}`
            const res = await ApigetPastReports(data,venuedata?.clientEntityId?.clientId?.ClientGroupName?.clientGroupName)
            if (res.status) {
                setdatalength(res.count)
                setreportdetails(res?.data)
            }
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
      venuedata &&  getreportdetails()
    }, [page, rowsPerPage, venuedata])

    const OpenEditReport = async (item: any) => {
        try {
            const data = {
                reportHeaderId: item.reportHeaderId,
                allocationId: item.allocationId,
                clientGroupName: venuedata?.clientEntityId?.clientId?.ClientGroupName?.clientGroupName
            }
            const res = await ApiReportTempToken(data)
            if (res.success) {
                sessionStorage.setItem('fromOriginalSite', 'true');
                window.open(`${process.env.REACT_APP_SHOPPER_SITE}?x-z-a=${res?.data?.token}`, '_blank');
            }
            else {
                toast.error(res?.message)
            }
        } catch (error: any) {
            toast.error(error?.message)
        }
    }

    return (
        <Box className='p-3 h-100 w-100'>
            <Typography variant='h4' className='text-center mb-4' fontWeight={'bolder'}>All Report Status</Typography>
            <TableContainer
                component={Paper}
                sx={{ border: "1px solid #ccc" }}
            >
                <Table>
                    <TableHead sx={{ bgcolor: "#7a7d52" }}>
                        <TableRow>
                            <TableCell>
                                <Typography className='text-white' variant='subtitle2'>Site Name</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography className='text-white' variant='subtitle2'>Group Name</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography className='text-center text-white' variant='subtitle2'>Month</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography className='text-center text-white' variant='subtitle2'>Created Date</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography className='text-center text-white' variant='subtitle2'>Visit Date</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography className='text-center text-white' variant='subtitle2'>Visit Time</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography className='text-white' variant='subtitle2'>Shopper</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography className='text-center text-white' variant='subtitle2'>Score</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography className='text-center text-white' variant='subtitle2'>Status</Typography>
                            </TableCell>
                            <TableCell>
                                <Typography className='text-center text-white' variant='subtitle2'>Edit</Typography>
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {reportdetails?.length > 0 ? (
                            reportdetails?.map((item: any, index: number) => (
                                <TableRow>
                                    <TableCell>
                                        <Typography className='' variant='subtitle2'>{venuedata?.venueName}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography className='' variant='subtitle2'>{venuedata?.clientEntityId?.clientId?.ClientGroupName?.clientGroupName}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography className='text-center' variant='subtitle2'>{item?.MonthYear}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography className='text-center' variant='subtitle2'>{dayjs(item?.reportCreatedDate).format("DD/MM/YYYY")}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography className='text-center' variant='subtitle2'>{dayjs(item?.inspectionDateTime).format("DD/MM/YYYY")}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography className='text-center' variant='subtitle2'>{item?.inspectionTime}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography  variant='subtitle2'>{item?.shopper}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography className='text-center' variant='subtitle2'>{item?.finalScore}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography className='text-center' variant='subtitle2'>{item?.reportStatus}</Typography>
                                    </TableCell>
                                    <TableCell className='text-center' sx={{cursor:"pointer"}} onClick={() => { OpenEditReport(item) }}>
                                        <Box component={'img'} src={edit} height={'24px'} width={'24px'}></Box>
                                    </TableCell>
                                </TableRow>
                            ))

                        ) : (<TableRow><TableCell colSpan={12}><Typography className='text-center'>No Reports Found</Typography></TableCell></TableRow>)
                        }
                    </TableBody>

                </Table>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    component="div"
                    count={datalength}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                />
            </TableContainer>
        </Box>
    )
}

export default VenueReportStatus
